/**
 * axiosConfig.js
 * Global axios interceptors for handling authentication errors
 *
 * NOTE: This module exports a function that accepts the axios instance to configure.
 * It must be called with the actual api instance used by the app.
 */

import { AUTH_TOKEN_KEY, USER_DATA_KEY } from '../constants';

/**
 * Setup axios interceptors on a specific axios instance
 * @param {Object} axiosInstance - The axios instance to configure (usually the 'api' instance)
 * @param {Function} onUnauthorized - Callback to execute on 401 errors (usually logout)
 */
export const setupAxiosInterceptors = (axiosInstance, onUnauthorized) => {
  // Response interceptor to handle 401 errors globally
  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        // Token expired or invalid - clear auth and redirect to login
        console.warn('🔒 Authentication error (401) - Token may be expired or invalid');

        // Clear stored auth data
        localStorage.removeItem(AUTH_TOKEN_KEY);
        localStorage.removeItem(USER_DATA_KEY);

        // Execute callback (usually logout)
        if (onUnauthorized) {
          onUnauthorized();
        }

        // Redirect to login if not already there
        if (window.location.pathname !== '/login') {
          console.warn('🔄 Redirecting to /login due to 401 error');
          window.location.href = '/login';
        }
      }

      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptors;
